export const FAVORITES_ADD_FAVORITE_REQUEST = 'FAVORITES_ADD_FAVORITE_REQUEST';
export const FAVORITES_ADD_FAVORITE_SUCCESS = 'FAVORITES_ADD_FAVORITE_SUCCESS';
export const FAVORITES_ADD_FAVORITE_ERROR = 'FAVORITES_ADD_FAVORITE_ERROR';
export const FAVORITES_UPDATE_FAVORITE_REQUEST = 'FAVORITES_UPDATE_FAVORITE_REQUEST';
export const FAVORITES_UPDATE_FAVORITE_SUCCESS = 'FAVORITES_UPDATE_FAVORITE_SUCCESS';
export const FAVORITES_UPDATE_FAVORITE_ERROR = 'FAVORITES_UPDATE_FAVORITE_ERROR';
